import * as React from 'react';
import marksActions from '../../../redux/marks/actions';
import { MarksState, MarksActionTypes } from '../../../redux/marks/types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../../redux/reducers';
import InputCodeModal from '../InputCodeModal';

const { closeConfirmCodeModal, confirmCodeMarks } = marksActions;

export interface MapStateToProps {
  /** stan otwarcia modala */
  opened: MarksState['codeConfirmModal']['opened'];
  /** stan ładowania modala */
  loading: MarksState['codeConfirmModal']['loading'];
  /** stan błędu */
  error: MarksState['codeConfirmModal']['error'];
  /** tryb modala - dostępny tryb 'sms' i 'email' */
  mode: MarksState['codeConfirmModal']['mode'];
}
export interface MapDispatchToProps {
  /** akcja zamknięcia modala */
  closeConfirmCodeModal: () => MarksActionTypes;
  /** akcja potwierdzenia wpisania kodu */
  confirmCodeMarks: (code: string, mode: MarksState['codeConfirmModal']['mode']) => MarksActionTypes;
}
export type Props = MapStateToProps & MapDispatchToProps;

/**
 * Komponent ogólny do zarządzania generowaniem odpowiedniego modala do wpisania kodu SMS/Email
 *
 */
export class InputCodeMarksModal extends React.Component<Props> {
  render(): React.ReactElement {
    const { opened, loading, error, mode, closeConfirmCodeModal, confirmCodeMarks } = this.props;
    return (
      <InputCodeModal
        opened={opened}
        loading={loading}
        error={error}
        mode={mode}
        confirm={confirmCodeMarks}
        close={closeConfirmCodeModal}
      />
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  opened: state.Marks.codeConfirmModal.opened,
  loading: state.Marks.codeConfirmModal.loading,
  error: state.Marks.codeConfirmModal.error,
  mode: state.Marks.codeConfirmModal.mode,
});

const mapDispatchToProps: MapDispatchToProps = {
  closeConfirmCodeModal,
  confirmCodeMarks,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(InputCodeMarksModal) as React.ComponentType<any>;
